import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as alerts from '../../_functions/alerts';
import { Parceiro } from '../../_models/parceiro';
import { AuthService } from '../../_services/auth.service';
import { FidelidadeService } from '../../_services/fidelidade.service';

@Component({
  selector: 'app-cadastro-parceiros',
  templateUrl: './cadastro-parceiros.component.html',
  styleUrls: ['./cadastro-parceiros.component.scss'],
})
export class CadastroParceirosComponent implements OnInit {
  // Form
  cadastroParceiroForm: UntypedFormGroup;

  public largura: any = screen.width;

  public exibePopupGenerico: boolean = false;
  public exibeCadastrado: boolean = true;
  public formErro: boolean = false;
  public enviando: boolean = false;
  public exibirModalConfirmarEnvioFormulario: boolean = false;
  public mensagem: string = '';

  private hashIndicacao: string = '';
  private tiposParceira: any[] = [];

  constructor(
    private fidelidadeService: FidelidadeService,
    private authService: AuthService,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute
  ) {
    this.cadastroParceiroForm = this.formBuilder.group({
      nome: ['', Validators.required],
      cnpj: ['', Validators.required],
      idTipoParceria: ['', Validators.required],
      urlSite: [''],
      redesSociais: ['', Validators.required],
      numeroSeguidores: ['', Validators.required],
      linkedIn: [''],
      nomeContato: ['', Validators.required],
      telefoneContato: ['', Validators.required],
      emailContato: ['', Validators.required],
      obervacoes: [''],
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (params.hashIndicacao) {
        this.hashIndicacao = params.hashIndicacao;
      }
    });

    this.fidelidadeService.obterTipos('Parceiro', 'IdTipoParceria').subscribe(
      (res) => this.processarSucessoBuscarTipoParceria(res),
      (err) => this.processarFalhaBuscarTipoParceria(err)
    );

    this.fidelidadeService
      .obterConfiguracaoPorDescricao('MensagemAceiteCadastroEmpresa')
      .subscribe(
        (res) => this.processarSucessoBuscarMensagemAceiteCadastroEmpresa(res),
        (err) => this.processarFalhaBuscarMensagemAceiteCadastroEmpresa(err)
      );
  }

  controlePopupCadastro(exibir: boolean) {
    var parceiro = new Parceiro(this.cadastroParceiroForm.value);
    parceiro.idStatus = 3;
    parceiro.hashIndicacao = this.hashIndicacao;

    const formData = new FormData();
    formData.append('parceiroAtualizarRequestModel', JSON.stringify(parceiro));
    formData.append('imagem', '');

    this.enviando = true;
    this.fidelidadeService.inserirParceiro(formData).subscribe(
      (res) => this.processarSucessoInserirParceiro(res, exibir),
      (err) => this.processarFalhaInserirParceiro(err)
    );
  }

  private processarSucessoInserirParceiro(res: any, exibir: boolean): void {
    this.exibirModalConfirmarEnvioFormulario = false;
    this.enviando = false;
    if (this.largura >= 767) {
      this.exibePopupGenerico = exibir;
    } else {
      this.exibeCadastrado = false;
    }
  }
  private processarFalhaInserirParceiro(err: any): void {
    this.enviando = false;
    this.exibirModalConfirmarEnvioFormulario = false;
    alerts.exibirToast('info', err.mensagensErro[0]);
  }

  irParaHome(): void {
    this.router.navigate(['/home']);
  }

  resetPagina(): void {
    this.router.navigate(['/cadastro_parceiros']);
  }

  novaParceria(): void {
    if (this.largura >= 767) {
      this.cadastroParceiroForm.reset();
      window.scroll({
        top: 0,
        left: 0,
      });

      this.exibePopupGenerico = false;
    } else {
      this.cadastroParceiroForm.reset();
      this.exibeCadastrado = true;
    }
  }

  public campo(p: any) {
    let input = document.getElementsByTagName('input')[p];
    if (input.value != '') {
    } else {
      alert('vazio');
    }
  }

  private processarSucessoBuscarTipoParceria(res: any) {
    this.tiposParceira = res;
  }

  private processarFalhaBuscarTipoParceria(res: any) {
    console.log(res);
  }

  ValidateNumber(event: any) {
    const pattern = /[0-9\+\-\ ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  abrirPopupEnvioFormulario() {
    this.formErro = !this.cadastroParceiroForm.valid;

    if (this.cadastroParceiroForm.valid) {
      var parceiro = new Parceiro(this.cadastroParceiroForm.value);

      if (!(parceiro.numeroSeguidores > 0)) {
        alerts.exibirToast(
          'info',
          'É necessário informar o número de seguidores!'
        );

        return;
      }

      this.exibirModalConfirmarEnvioFormulario = true;
    } else this.cadastroParceiroForm.updateValueAndValidity();
  }

  fecharPopupEnvioFormulario() {
    this.exibirModalConfirmarEnvioFormulario = false;
  }

  processarSucessoBuscarMensagemAceiteCadastroEmpresa(res: any) {
    this.mensagem = res.valor;
  }

  processarFalhaBuscarMensagemAceiteCadastroEmpresa(res: any) {
    console.log(res);
  }
}
